import React from 'react'
import classnames from 'classnames'
import PropTypes from 'prop-types'
import { withI18nContext } from '@mc/i18n'
import i18nInstance from '../../../../i18n/i18nInstance'

class NextArrow extends React.PureComponent {
  clickHandler(options, e) {
    if (e) e.preventDefault()
    this.props.clickHandler(options, e)
  }

  render() {
    const nextClasses = {
      'slick-arrow': true,
      'slick-next': true,
    }
    let nextHandler = this.clickHandler.bind(this, { message: 'next' })

    let nextArrowProps = {}

    if (!this.props.canGoNext) {
      nextClasses['slick-disabled'] = true
      nextHandler = null
      nextArrowProps.disabled = true
    }

    nextArrowProps = {
      ...nextArrowProps,
      key: '1',
      className: classnames(nextClasses),
      style: { display: 'block' },
      onClick: nextHandler,
    }

    const nextArrow = this.props.nextArrow ? (
      React.cloneElement(this.props.nextArrow, {
        ...nextArrowProps,
        currentSlide: this.props.currentSlide,
        slideCount: this.props.slideCount,
      })
    ) : (
      <button key='1' type='button' {...nextArrowProps}>
        {this.props.t('carousel.nextButtonAlt')}
      </button>
    )

    return nextArrow
  }
}

NextArrow.propTypes = {
  clickHandler: PropTypes.func.isRequired,
  currentSlide: PropTypes.number.isRequired,
  slideCount: PropTypes.number.isRequired,
  nextArrow: PropTypes.node,
  canGoNext: PropTypes.bool,
  t: PropTypes.func,
}

export default withI18nContext(i18nInstance)(NextArrow)
